// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"718":"5c08bb68","821":"b7c38528"}[chunkId] + ".chunk.js";
};